import CameraAltIcon from '@mui/icons-material/CameraAlt';
import ChecklistIcon from '@mui/icons-material/Checklist';
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
import PersonIcon from '@mui/icons-material/Person';
import { Box, Card, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { useGetDashboardSummary } from '../../services/react-query/dashboard/useGetDashboardSummary';
import {
  summaryCardStyles,
  summaryContainerStyles,
  summaryHeaderStyles,
  summaryItemCountStyles,
  summaryItemHeaderStyles,
  summaryItemIconStyles,
  summaryItemLabelStyles,
} from './dashboardStyles';
import { useGetCurrentUserSettings } from '../../services/react-query/users/useGetCurrentUserSettings';

const SummaryPanel: React.FC = () => {
  const { data, isLoading, error } = useGetDashboardSummary();
  const { data: currentUserSettings } = useGetCurrentUserSettings();

  if (!currentUserSettings?.settings.isAdmin) return null;

  if (isLoading) return <Typography>Loading...</Typography>;
  if (error instanceof Error) return <Typography>Error: {error.message}</Typography>;

  const blue = '#147ad6';

  const summaryItems = [
    {
      count: data?.this_weeks_scheduled_events ?? 'N/A',
      label: "This week's scheduled events",
      icon: <EventAvailableRoundedIcon sx={{ fontSize: 25, color: blue }} />,
    },
    {
      count: data?.active_employees ?? 'N/A',
      label: "This week's active employees",
      icon: <CameraAltIcon sx={{ fontSize: 25, color: blue }} />,
    },
    {
      count: data?.upcoming_unscheduled_events ?? 'N/A',
      label: 'Upcoming unscheduled events',
      icon: <ChecklistIcon sx={{ fontSize: 25, color: blue }} />,
    },
    {
      count: data?.active_accounts ?? 'N/A',
      label: 'Active Accounts',
      icon: <PersonIcon sx={{ fontSize: 25, color: blue }} />,
    },
    {
      count: data?.upcoming_scheduled_events ?? 'N/A',
      label: 'Upcoming scheduled events',
      icon: <PersonIcon sx={{ fontSize: 25, color: blue }} />,
    },
  ];

  return (
    <Box component={Paper} sx={summaryContainerStyles}>
      <Typography variant="h6" sx={summaryHeaderStyles}>
        Summary
      </Typography>

      <Stack spacing={2} sx={{ height: '100%' }}>
        {summaryItems.map((item, index) => (
          <Card key={index} sx={summaryCardStyles}>
            <Box sx={summaryItemHeaderStyles}>
              <Box sx={summaryItemIconStyles}>{item.icon}</Box>

              <Typography variant="h6" sx={summaryItemCountStyles}>
                {item.count}
              </Typography>
            </Box>

            <Box>
              <Typography variant="body2" sx={summaryItemLabelStyles}>
                {item.label}
              </Typography>
            </Box>
          </Card>
        ))}
      </Stack>
    </Box>
  );
};

export { SummaryPanel };
